const NewPayment = () => import('@/components/auth/NewPayment.vue')
const NewPaymentAccount = () => import('@/components/auth/NewPayment.vue')
const BusinessPayment = () => import('@/components/conekta/BusinessPayment.vue')

export const paymentRoutes = [
  {path: '/new-payment', component: NewPayment, props: route => ({ query: route.query.token }), meta: { breadcrumb: 'Renovación de Paquete' } },
  {path: '/new-payment-account', component: NewPaymentAccount, props: route => ({ query: route.query.token }), meta: { breadcrumb: 'Renovación de Cuenta', requiresAuth: true } },
  {path: '/payment-business', component: BusinessPayment, props: route => ({ query: route.query.token }) },
]
